import { State } from "@store/types";
import { PulsePollCommentsReportStateProps } from "./reducer";

export function getPulsePollCommentsReportState(state: State) {
  return state.getIn(["pulse_poll", "comments"]) as PulsePollCommentsReportStateProps;
}